import type { ReactNode } from 'react';

type StatusKind = 'ok' | 'warn' | 'mute' | 'run';

type StatusProps = {
  kind?: StatusKind;
  children: ReactNode;
};

/**
 * The "no-pill" status indicator from MAFA: a coloured dot + a label.
 * The `run` variant emits the pulsing animation from styles.css.
 */
export function Status({ kind, children }: StatusProps) {
  return (
    <span className={'status' + (kind ? ` ${kind}` : '')}>
      <span className="dt" />
      {children}
    </span>
  );
}
